import $ from "jquery";
import deps from "../../../../assets/js/lib/dependencies";
import { goToByScroll } from "../../../../assets/js/lib/content/helper";

const Flickity = deps.flickity;

/**
 * Init the photo slider of a day
 *
 * The sliders live inside a collapsed `max-height: 0` container, so Flickity would measure zero
 * width if it were initialised on page load through its own `data-flickity` attribute. Each day
 * therefore carries its settings in `data-flickity-settings` and gets its slider the first time it
 * opens; every following open only needs a resize, because the container may have changed width.
 */
function initItinerarySlider(item) {
    const slider = item.querySelector("[data-itinerary-slider]");

    if (!slider) {
        return;
    }

    const existing = Flickity.data(slider);

    if (existing) {
        existing.resize();
        return;
    }

    // One photo is not a slider — it keeps the arrows and dots off the image.
    if (slider.children.length < 2) {
        return;
    }

    const settings = JSON.parse(slider.getAttribute("data-flickity-settings"));

    new Flickity(slider, settings);

    // A photo is not a link: clicking one does nothing on purpose. The day already shows the photo
    // at the size the design gives it, so there is no lightbox to open.
    $(slider).on("dragStart.flickity", () => $(slider).addClass("s_is-dragging"));
    $(slider).on("dragEnd.flickity", () => $(slider).removeClass("s_is-dragging"));
}

/**
 * On click on itinerary toggle btn — show or hide the days beyond the visible rows
 *
 * Every lookup stays inside the section the button belongs to: the kitchensink puts several
 * itinerary blocks on one page, and a page-wide selector would toggle all of them at once.
 */
$("[data-itinerary-toggle-btn]").on("click tap", function () {
    const $items = $(this)
        .closest('[data-s-type="template-itinerary"]')
        .find("[data-itinerary-toggle]");
    const isCollapsed = $items.hasClass("s_is-collapsed");

    $items.toggleClass("s_is-collapsed");

    $(this)
        .find(".sb_template-itinerary_more_label")
        .text(
            isCollapsed
                ? $(this).data("itinerary-collapse-text")
                : $(this).data("itinerary-expand-text")
        );

    $(this).find(".sb_icon-plusmin").toggleClass("s_is-open", isCollapsed);
});

/**
 * On click on itinerary item
 */
$("[data-itinerary-item]").on("click tap", function () {
    const point_id = $(this).attr("data-point-id");
    const $item = $(this).parent();
    const isAlreadyOpen = $item.hasClass("s_is-open");

    // Close all open items in this section
    $(this)
        .closest('[data-s-type="template-itinerary"]')
        .find("[data-itinerary-item]")
        .attr("aria-expanded", "false")
        .parent()
        .removeClass("s_is-open");

    if (isAlreadyOpen) {
        return;
    }

    // Clicked a different day — open it
    $item.addClass("s_is-open");
    $(this).attr("aria-expanded", "true");

    initItinerarySlider($item[0]);

    goToByScroll(`[data-point-id="${point_id}"]`, 140, 300, "body, html");
});

/**
 * Run on page load
 *
 * The first day is open in the design, so its slider is the one that needs to exist right away.
 */
$(function () {
    $(".sb_template-itinerary_item.s_is-open").each((i, item) =>
        initItinerarySlider(item)
    );
});
